// Third-party
import React from 'react';

// Component Library
import { Pill, PillTone, PillVariant, PillSize } from '@capintel/component-lib/pill';

// Utils
import { formatMessage } from '../../../utils/i18n';
import PortfolioType from '@/types/portfolio-type';

type Props = {
  portfolioType: PortfolioType;
  size?: PillSize;
};

const getPillVariant = (
  portfolioType: PortfolioType,
): {
  variant: PillVariant;
  tone?: PillTone;
} => {
  switch (portfolioType) {
    case 'CLIENT':
      return { variant: 'custom', tone: PillTone.tone1 };
    case 'TEMPLATE':
      return { variant: 'custom', tone: PillTone.tone2 };
    case 'FIRM':
      return { variant: 'custom', tone: PillTone.tone3 };
    case 'CUSTOM':
      return { variant: 'custom', tone: PillTone.tone4 };
    case 'UNASSIGNED':
    case 'DELETED':
    default:
      return { variant: 'default' };
  }
};

const PortfolioTypeLabel = ({ portfolioType, size = 'small' }: Props) => {
  const pillProps = getPillVariant(portfolioType);

  return (
    <Pill variant={pillProps.variant} tone={pillProps.tone} size={size}>
      {formatMessage(`PortfolioType.${portfolioType}`)}
    </Pill>
  );
};

export default PortfolioTypeLabel;
